import type { BatteryChemistry } from '@brt/shared-types'

const CHEM_SEMANTIC: Record<string, 'safe' | 'caution' | 'danger'> = {
  LI_FEPO4: 'safe',
  LI_ION: 'safe',
  LEAD_ACID_FLOODED: 'caution',
  AGM: 'caution',
  GEL: 'caution',
  NI_MH: 'safe',
  NI_CD: 'safe',
  ALKALINE: 'danger',
  CUSTOM: 'safe',
}

interface TemperatureDeratingDisplayProps {
  factor: number
  chemistry: BatteryChemistry
}

export default function TemperatureDeratingDisplay({ factor, chemistry }: TemperatureDeratingDisplayProps) {
  const semantic = CHEM_SEMANTIC[chemistry] ?? 'safe'
  const percent = Math.round(factor * 100)
  const isDerated = factor < 0.99

  return (
    <div
      className={`temp-derating ${isDerated ? `temp-derating--${semantic}` : 'temp-derating--nominal'}`}
      aria-label={`Temperature derating: ${percent}%`}
    >
      <span className="temp-derating__label">Temp derating:</span>
      <span className="temp-derating__value">×{factor.toFixed(2)}</span>
      {isDerated && (
        <span className="temp-derating__percent">({percent}%)</span>
      )}
    </div>
  )
}
